import { Basket, BasketItem } from 'entities/compilationContext/OnsiteCompilationContext/Basket';
import { OnsiteCompilationContext } from 'entities/compilationContext/OnsiteCompilationContext/OnsiteCompilationContext';
import { IBasket, IBasketItem } from 'entities/compilationContext/basket';
import { ICompilationContext, Snapshot } from 'entities/compilationContext/compilation-context';

/**
 * Maps the offsite randomised snapshots to an onsite structure. Offsite snapshots
 * must be used in order to take advantage of the live data. Live impressions
 * cannot be used as they are not guaranteed to have all of the data required, or
 * guaranteed to have happened.
 */
export class OnsiteRandomiseSnapshotMapper {
  private mapBasketItem(i: IBasketItem): BasketItem {
    return {
      product: i.product,
      costs: i.costs,
      quantity: i.quantity ? Number.parseInt(i.quantity) : null,
      tagBag: i.tagBag,
    };
  }

  private mapBasket(b: IBasket): Basket {
    return {
      currency: b.currency,
      currencySymbol: b.currencySymbol,
      costs: b.costs,
      discount: b.discount,
      items: b.items?.length ? b.items.map<BasketItem>(this.mapBasketItem) : [],
      repopulationURL: b.repopulationUrl,
      type: b.type,
      tagBag: b.tagBag,
    };
  }

  public map(data: Snapshot<ICompilationContext>[]): Snapshot<OnsiteCompilationContext>[] {
    return data.map<Snapshot<OnsiteCompilationContext>>(s => {
      return {
        ...s,
        compilationContext: {
          basket: this.mapBasket(s.compilationContext.abandonedBasket),
          locale: s.compilationContext.locale,
          sendOverride: s.compilationContext.sendOverride,
          product: s.compilationContext.browsedProducts
            ? (s.compilationContext.browsedProducts[0] as any).product // Browsed products has a `product` property, so need to access that and the interfaces don't match up.
            : null,
          tagBag: s.compilationContext.tagBag,
        },
      };
    });
  }
}
